import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutTrust from './components/AboutTrust';
import CategoryGrid from './components/CategoryGrid';
import ArticleHighlights from './components/ArticleHighlights';
import CTASection from './components/CTASection';
import EditorialTrust from './components/EditorialTrust';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.cfd';

export default function Home() {
  return (
    <>
      {/* Structured Data: Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'itaobuyspread.cfd',
            url: siteUrl,
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
            description: 'Itaobuy Spreadsheet è la piattaforma di ricerca prodotti più completa per lo shopping online. Scopri scarpe, hoodie, sneakers, accessori e molto altro.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />

      {/* Structured Data: WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'itaobuyspread.cfd',
            url: siteUrl,
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `${siteUrl}/?q={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <main className="min-h-screen bg-background-50">
        <Navbar />
        <Hero />
        <AboutTrust />
        <CategoryGrid />
        <ArticleHighlights />
        <CTASection />
        <EditorialTrust />
        <Footer />
      </main>
    </>
  );
}